import { z } from 'zod'

export const WhitelistDomainSchema = z.object({
  deletable: z.boolean(),
  domain: z.string(),
  fb_verified: z.boolean(),
})
